import React from "react";
import { Card,  Typography, Table,Avatar,Tabs } from "antd";


import {  ArrowLeftOutlined } from "@ant-design/icons";


const { Title } = Typography;
const { TabPane } = Tabs;

export default function ServerTips({order,setShowDetails}) {
  
    const onChange = () => {};
      const columnsPickup = [
        {
          title: "Order ID",
          dataIndex: "order_id",
          key: "order_id",
          render: (_, record) => {
            return (
              <div>
                <div  className="name_text">
                  {record.order_id}
                </div>
              </div>
            );
          },
        },
        {
            title: "Table No.",
            dataIndex: "table_no",
            key: "table_no",
            render: (_, record) => {
              return (
                <div>
                  <div  className="name_text">
                    {record.table_no}
                  </div>
                </div>
              );
            },
          },
          {
            title: "Tips Recieved",
            dataIndex: "tip_received",
            key: "tip_received",
            render: (_, record) => {
              return (
                <div>
                  <div  className="name_text">
                    {record.tip_received}
                  </div>
                </div>
              );
            },
          },]

    return (
        <div>
             <div className="catering-header">
        <Title level={4} style={{cursor:"pointer"}}
        onClick={()=>setShowDetails(false)}> <ArrowLeftOutlined/> Tip</Title>
      </div>

      <div style={{ marginTop: 40 }}>
        <Card className="tip-details-header">
            <div className="header-content">
        <div style={{ display: "flex",alignItems:"center" }} >
                   <Avatar style={{ marginRight:"10px" }} size={60} src={order?.photo_url} />
                   <div>
                    <div className="driver-name">{order?.name}</div>
                    <div className="type-user">Server</div>
                   </div>

            </div>
            <div className="total-tip">Total Tip: ${order?.total_tips}</div>
            </div>
        </Card>
       
        <Tabs
          className="customer-tab"
          defaultActiveKey="active"
          onChange={onChange}
          size={"large"}
        >
          <TabPane tab="Tips in Cash" key="cash-tip">
          <Table
            columns={columnsPickup}
            dataSource={order?.tip_details?.filter((item)=> item.payment_type === 'Cash')}
            className="discount-table"
            
          />
          </TabPane>
         
          <TabPane tab="Card Tips" key="card-tip">
          <Table
            columns={columnsPickup}
            dataSource={order?.tip_details?.filter((item)=> item.payment_type !== 'Cash')}
            className="discount-table"
            
          />
          </TabPane>
        </Tabs>
            </div>
        </div>
    );
  }





